export default {
  // 模块id
  moduleId: (state) => state.common.moduleId,
  // 组织架构
  organizations: (state) => state.common.organizations,
  // 默认列表页的查询框是否展开
  searchFormIsOpen: (state) => state.common.searchFormIsOpen,
  // 用户id
  userId: (state) => state.user.userId,
  // 登录名
  userCode: (state) => state.user.userCode,
  // 用户名
  userName: (state) => state.user.userName,
  // 用户类型
  userSourceType: (state) => state.user.userSourceType,
  // 企业类型
  corpId: (state) => state.user.corpId,
  // 子标题
  subModuleTitle: (state) => state.user.subModuleTitle,
  // 动态路由列表
  addRouters: (state) => state.permission.addRouters,
  // 菜单列表
  menus: (state) => state.permission.menus,
};
